{% block sw_cms_element_preview_top_finder_selectboxes %}
    <div class="sw-cms-el-preview-top-finder-selectboxes">
        <span class="sw-cms-el-preview-top-finder-selectboxes__label">TopFinder</span>
        <div class="sw-cms-el-preview-top-finder-selectboxes__dropdowns">
            <span class="sw-cms-el-preview-top-finder-selectboxes__pill">Brand</span>
            <span class="sw-cms-el-preview-top-finder-selectboxes__pill">Series</span>
            <span class="sw-cms-el-preview-top-finder-selectboxes__pill">Device</span>
        </div>
    </div>
{% endblock %}
